import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { archiveBusinessPartner } from 'scenes/BusinessPartners/sources/businessPartners';

import { archive } from '../queryKeyFactory';

export const useArchiveBusinessPartner = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const archiveMutation = useMutation(archive(), archiveBusinessPartner, {
    successMessage: (_data) => {
      return `Business Partner deactivated`;
    },
  });

  const handleAction = async ({ id, name }) => {
    await showModal({
      title: 'Deactivate Business Partner?',
      confirmActionLabel: 'Deactivate',
      bodyText: `«${name}»`,
    });

    await archiveMutation.mutateAsync({ id });
  };
  return [handleAction, archiveMutation];
};
